import type { ReactNode } from 'react';

import { cn } from '../../../lib/cn';

/**
 * Dải báo trên đầu vùng nội dung: thông tin (xám), cảnh báo (hổ phách), lỗi (đỏ, `role="alert"`). Lỗi tải
 * kèm `hanhDong` (nút `Thử lại`) đặt ngay cạnh câu lỗi.
 */
export function DaiBao({
  tong,
  hanhDong,
  children,
}: {
  tong: 'thongTin' | 'canhBao' | 'loi';
  hanhDong?: ReactNode;
  children: ReactNode;
}) {
  const mau = tong === 'loi' ? 'text-danger-700' : tong === 'canhBao' ? 'text-warning-700' : 'text-content-secondary';
  return (
    <div
      role={tong === 'loi' ? 'alert' : undefined}
      className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-default bg-surface px-4 py-3 shadow-sm"
    >
      <p className={cn('min-w-0 flex-1 text-sm leading-relaxed', mau)}>{children}</p>
      {hanhDong && <div className="shrink-0">{hanhDong}</div>}
    </div>
  );
}
